export class Codigo {
    static storageService: any;

    static getPlan() {
        return [
            {
                codigo: "A",
                value: 1,
                descripcion: "Asociado",
            },
            {
                codigo: "F",
                value: 2,
                descripcion: "Familiar",
            },
            {
                codigo: "C",
                value: 3,
                descripcion: "Colectivo",
            }
        ];
    }

    static getPrograma() {
        return [
            {
                plan: "ORO",
                codigo: "OROA",
                descripcion: "ORO ASOCIADO",
                planCodigo: "A",
                img: "./assets/imagenes/ORO.png"
            },
            {
                plan: "ORO",
                codigo: "OROF",
                descripcion: "ORO FAMILIAR",
                planCodigo: "F",
                img: "./assets/imagenes/ORO.png"
            },
            {
                plan: "ORO",
                codigo: "ORGC",
                descripcion: "ORO COLECTIVO",
                planCodigo: "C",
                img: "./assets/imagenes/ORO.png"
            },
            {
                plan: "PLATA",
                codigo: "PLAA",
                descripcion: "PLATA ASOCIADO",
                planCodigo: "A",
                img: "./assets/imagenes/DIGITAL_GENRICA0.png"
            },
            {
                plan: "PLATA",
                codigo: "PLAF",
                descripcion: "PLATA FAMILIAR",
                planCodigo: "F",
                img: "./assets/imagenes/DIGITAL_GENRICA0.png"
            },
            {
                plan: "PLATA",
                codigo: "PLAC",
                descripcion: "PLATA COLECTIVO",
                planCodigo: "C",
                img: "./assets/imagenes/DIGITAL_GENRICA0.png"
            },
            {
                plan: "ASOCIADO",
                codigo: "ASOA",
                descripcion: "ASOCIADO",
                planCodigo: "A"
            },
            {
                plan: "ASOCIADO",
                codigo: "ASOC",
                descripcion: "ASOCIADO COLECTIVO",
                planCodigo: "C"
            },
            {
                plan: "CLASICO",
                codigo: "CLAA",
                descripcion: "CLASICO ASOCIADO",
                planCodigo: "A",
                img: "./assets/imagenes/DIGITAL_GENRICA.png"
            },
            {
                plan: "CLASICO",
                codigo: "CLAF",
                descripcion: "CLASICO FAMILIAR",
                planCodigo: "F",
                img: "./assets/imagenes/DIGITAL_GENRICA.png"
            },
            {
                plan: "CLASICO",
                codigo: "CLAC",
                descripcion: "CLASICO COLECTIVO",
                planCodigo: "C",
                img: "./assets/imagenes/DIGITAL_GENRICA.png"
            },
            {
                plan: "HOSPITALIZACION CIRUGIA MATERNIDAD",
                codigo: "HCMA",
                descripcion: "HCM ASOCIADO",
                planCodigo: "A",
                img: "./assets/imagenes/DIGITAL_GENRICA 2.png"
            },
            {
                plan: "HOSPITALIZACION CIRUGIA MATERNIDAD",
                codigo: "HCMF",
                descripcion: "HCM FAMILIAR",
                planCodigo: "F",
                img: "./assets/imagenes/DIGITAL_GENRICA 2.png"
            },
            {
                plan: "HOSPITALIZACION CIRUGIA MATERNIDAD",
                codigo: "HCMC",
                descripcion: "HCM COLECTIVO",
                planCodigo: "C",
                img: "./assets/imagenes/DIGITAL_GENRICA 2.png"
            },
            {
                plan: "ORO PLUS",
                codigo: "OPLF",
                descripcion: "ORO PLUS FAMILIAR",
                planCodigo: "F"
            },
            {
                plan: "ORO PLUS",
                codigo: "OPLA",
                descripcion: "ORO PLUS ASOCIADO",
                planCodigo: "A"
            },
            {
                plan: "ORO PLUS",
                codigo: "OPLC",
                descripcion: "ORO PLUS COLECTIVO",
                planCodigo: "C"
            },
            {
                plan: "PLATA JOVEN",
                codigo: "PJVA",
                descripcion: "PLATA JOVEN ASOCIADO",
                planCodigo: "A"
            },
            {
                plan: "PLATA JOVEN",
                codigo: "PJVC",
                descripcion: "PLATA JOVEN COLECTIVO",
                planCodigo: "C"
            },
            {
                plan: "PLATA JOVEN",
                codigo: "PJVF",
                descripcion: "PLATA JOVEN FAMILIAR",
                planCodigo: "F"
            },
            {
                plan: "PLATA PRIME",
                codigo: "PRIMA",
                descripcion: "PLATA PRIME ASOCIADO",
                planCodigo: "A"
            },
            {
                plan: "PLATA PRIME",
                codigo: "PRIMC",
                descripcion: "PLATA PRIME COLECTIVO",
                planCodigo: "C"
            },
            {
                plan: "PLATA PRIME",
                codigo: "PRIMF",
                descripcion: "PLATA PRIME FAMILIAR",
                planCodigo: "F"
            },
            {
                plan: "AMBULATORIO ESPECIAL",
                codigo: "AESC",
                descripcion: "AMBULATORIO ESPECIAL COLECTIVO",
                planCodigo: "C"
            },
            {
                plan: "AMBULATORIO ESPECIAL",
                codigo: "AESF",
                descripcion: "AMBULATORIO ESPECIAL FAMILIAR",
                planCodigo: "F"
            },
            {
                plan: "TRADICIONAL",
                codigo: "TRDA",
                descripcion: "TRADICIONAL ASOCIADO",
                planCodigo: "A",
                img: "./assets/imagenes/DIGITAL_GENRICA3.png"
            },
            {
                plan: "TRADICIONAL",
                codigo: "TRDC",
                descripcion: "TRADICIONAL COLECTIVO",
                planCodigo: "C",
                img: "./assets/imagenes/DIGITAL_GENRICA3.png"
            },
            {
                plan: "TRADICIONAL",
                codigo: "TRDF",
                descripcion: "TRADICIONAL FAMILIAR",
                planCodigo: "F",
                img: "./assets/imagenes/DIGITAL_GENRICA3.png"
            },
            {
                plan: "TRADICIONAL ESPECIAL",
                codigo: "TESC",
                descripcion: "TRADICIONAL ESPECIAL COLECTIVO",
                planCodigo: "C",
                img: "./assets/imagenes/TRADICIONAL ESPECIAL.png"
            },
            {
                plan: "TRADICIONAL ESPECIAL",
                codigo: "TESF",
                descripcion: "TRADICIONAL ESPECIAL FAMILIAR",
                planCodigo: "F",
                img: "./assets/imagenes/TRADICIONAL ESPECIAL.png"
            },
            {
                plan: "TRADICIONAL ESPECIAL",
                codigo: "TESA",
                descripcion: "TRADICIONAL ESPECIAL ASOCIADO",
                planCodigo: "A",
                img: "./assets/imagenes/TRADICIONAL ESPECIAL.png"
            },
        ]
    }

    static getLineaNegocio() {
        return [
            {
                codigo: "1",
                nombre: "Medicina integral",
                valor: "SMP",
            },
            {
                codigo: "2",
                nombre: "Salud oral",
                valor: "SAO",
            },
            {
                codigo: "3",
                nombre: "CEM",
                valor: "CEM",
            },
        ]
    }

    static getSucursal() {
        var sucursal = "";
        var result = sessionStorage.getItem("LoginR");
        if (result != "" && result != null) {
            var login = JSON.parse(result);
            if (login.sucursales.length > 0) {
                sucursal = login.sucursales[0].codigo;
            }
        }
        return sucursal;
    }

    static getAsesor() {

        var asesor = null;
        var result = Codigo.storageService.getItem('user');
        if (result != "" && result != null) {
            var login = JSON.parse(result);
            asesor = login.document
        }

        return asesor;
    }

    static getDate() {

        var fecha = "";
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()

        if (month < 10) {
            fecha = `${year}-0${month}-${day}`;
        } else {
            fecha = `${year}-${month}-${day}`;
        }

        return fecha;
    }

    /** No borrar */
    static getDataCodeProgramas() {
        const data = [
            {
                plan: 'F',
                config: [
                    {
                        programa: 'SMP',
                        code: ['OPL', 'PJV'],
                        subcode: ['OPLF', 'PJVF']
                    },
                    {
                        programa: 'SAO',
                        code: ['SOEL'],
                        subcode: ['SAOB']
                    }
                ]
            },
            {
                plan: 'A',
                config: [
                    {
                        programa: 'SMP',
                        code: ['OPL', 'PJV', 'ASO', 'TES'],
                        subcode: ['OPLA', 'PJVA', 'ASOA', 'TESA']
                    },
                    {
                        programa: 'SAO',
                        code: ['SOEL'],
                        subcode: ['SAOB']
                    }
                ]
            },
            {
                plan: 'C',
                config: [
                    {
                        programa: 'SMP',
                        code: ['ORO', 'OPL', 'PJV', 'TES', 'PLAT', 'HCM'],
                        subcode: ['OROC', 'OPLC', 'PJVC', 'TESC', 'PLATC', 'HCMC']
                    },
                    {
                        programa: 'SAO',
                        code: ['SOEL', 'SAOR', 'SDEP'],
                        subcode: ['DEB', 'SAOB', 'DECERC']
                    }
                ]
            }

        ]
        return data;
    }
}